
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.778 0H2.223A2.23 2.23 0 000 2.221V12.78C0 14 1 15 2.223 15h15.555C19.001 15 20 14 20 12.778V2.222C20 1 19 0 17.778 0zm1.39 12.547c0 1.12-.5 1.62-1.62 1.62H2.455c-1.12 0-1.62-.5-1.62-1.62V2.45c0-1.12.5-1.62 1.62-1.62h15.093c1.12 0 1.62.5 1.62 1.62zM6.25 5.833l2.082 1.666 5.417-4.584 4.167 3.751v6.251H2.084v-3.75zm-2.5-3.75a1.668 1.668 0 10.001 3.336 1.668 1.668 0 000-3.336z"}})])
          )
        }
      }
    